<div class="card" *ngIf="!isLoading">
  <div class="card__infos">
    <span class="card__infos__title"> {{ title }} </span>
    <span class="card__infos__value" [ngStyle]="{ color: color }">{{ value }}</span>
    <div *ngIf="description" class="card__infos__description" [innerHTML]="description"></div>
  </div>
  <div class="card__buttons" *ngIf="seeMore || info">
    <mat-icon
      *ngIf="seeMore"
      class="card__buttons__see-more"
      (click)="clickSeeMore.emit()"
      [matTooltip]="'FC_DATA_CARD.SEE_MORE' | translate"
      [matTooltipShowDelay]="500"
      matTooltipPosition="left"
    >
      remove_red_eye
    </mat-icon>
    <mat-icon
      *ngIf="info"
      class="card__buttons__info"
      [matTooltip]="info"
      [matTooltipShowDelay]="500"
      matTooltipPosition="left"
    >
      info_outline
    </mat-icon>
  </div>
</div>

<ngx-skeleton-loader
  *ngIf="isLoading"
  class="card-skeleton"
  [theme]="{ height: '100%', width: '100%', margin: '0', padding: '0' }"
></ngx-skeleton-loader>
